"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EobModule = void 0;
const React = require("react");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const eob_checks_paid_1 = require("./tabs/eob-checks-paid");
const eob_checks_received_1 = require("./tabs/eob-checks-received");
const eob_fees_1 = require("./tabs/eob-fees");
const eob_payback_1 = require("./tabs/eob-payback");
const mobx_1 = require("mobx");
require("./eob.less");
class EobModule extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.withPadding = true;
        // console.log("eobStore.showHistory is", eobStore.showHistory);
        this.addTab("EOB Details and Fees", () => `/eob/eobfees`, /^\/eob\/eobfees\/?$/, eob_fees_1.FeesTab
        // eobStore.showHistory ? EobHistoryTab : FeesTab
        );
        this.addTab("Checks Payable", () => `/eob/eobchecks-paid`, /^\/eob\/eobchecks-paid\/?$/, eob_checks_paid_1.ChecksPaidTab);
        this.addTab("Checks Recievable", () => `/eob/eobchecks-received`, /^\/eob\/eobchecks-received\/?$/, eob_checks_received_1.ChecksReceivedTab);
        // this.addTab(
        //   "Eob History",
        //   () => `/eob/eob-history`,
        //   /^\/eob\/eob-history\/?$/,
        //   EobHistoryTab
        // );
        this.addTab("Negative Balance Payback", () => `/eob/eobpayback`, /^\/eob\/eobpayback\/?$/, eob_payback_1.PaybackTab);
    }
    componentDidMount() {
        mobx_1.autorun(() => {
            if (!store_1.usersStore.user.loading &&
                !store_1.usersStore.user.error &&
                store_1.usersStore.user.value &&
                (location.pathname === "/eob" || location.pathname === "/eob/")) {
                location.href = "/eob/eobfees";
            }
        });
    }
    render() {
        return (React.createElement("div", { className: "eob" }, store_1.usersStore.permissions.ReadEOB ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(kpi_title_1.KpiTitle, { label: "EOB" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "eob__tabs" }, super.render())))) : (store_1.usersStore.showLock())));
    }
}
exports.EobModule = EobModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/eob.tsx
// module id = 3414
// module chunks = 0